import { render, staticRenderFns } from "./multi-data-subject-search.vue?vue&type=template&id=51681be5"
import script from "./multi-data-subject-search.vue?vue&type=script&lang=js"
export * from "./multi-data-subject-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports